import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DebugFlagsService } from '@content-platform/web-angular-shared-util-development';
import { UserRequestComponent } from '../user-request/user-request.component';
import {
  Role,
  fromApplication,
  roleSelectors,
  roleActions,
} from '@content-platform/web/angular/shared/data-access/application-api';
import { Auth } from '@content-platform/web-angular-shared-util-auth';
import { Store, select } from '@ngrx/store';
import { tap, filter, take } from 'rxjs/operators';

export interface AdministrationState {
  auth: Auth;
  application: fromApplication.State;
}

@Injectable()
export class UserRequestDialogService {
  constructor(
    private dialog: MatDialog,
    private store: Store<AdministrationState>,
    private debugFlagsService: DebugFlagsService
  ) {}

  showInviteUserModal() {
    const roleList$ = this.store.pipe(
      select(roleSelectors.getAllRoleItems),

      tap((roleList) => {
        if (!!roleList && roleList.length === 0) {
          this.store.dispatch(new roleActions.Load());
        }
      }),
      filter((roleList) => !!roleList && roleList.length > 0),
      take(1)
    );

    roleList$.subscribe((roleList) => {
      this.openDialog(roleList);
    });
  }

  openDialog(availableRoles: Role[]) {
    this.dialog.open(UserRequestComponent, {
      width: '400px',
      autoFocus: false,
      panelClass: 'modalPopup',
      data: {
        flags: this.debugFlagsService.flags,
        settings: this.debugFlagsService.settings,
        roles: availableRoles,
      },
    });
  }
}
